import { render, staticRenderFns } from "./ResumoRepasseMe.vue?vue&type=template&id=0012bfd2&scoped=true"
import script from "./ResumoRepasseMe.vue?vue&type=script&lang=js"
export * from "./ResumoRepasseMe.vue?vue&type=script&lang=js"
import style0 from "./ResumoRepasseMe.vue?vue&type=style&index=0&id=0012bfd2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0012bfd2",
  null
  
)

export default component.exports